import { Config } from 'plotly.js';

export const spectraChartConfig: Partial<Config> = {
  displayModeBar: true,
  responsive: true,
  displaylogo: false,
  toImageButtonOptions: {
    format: 'jpeg' as const,
    filename: 'wave-spectra',
    height: 800,
    width: 1200,
    scale: 1,
  },
  scrollZoom: true,
  modeBarButtonsToRemove: ['lasso2d', 'select2d'],
};

export const RESET_AXES_ICON = {
  width: 928.6,
  height: 1000,
  path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
  transform: 'matrix(1 0 0 -1 0 850)',
};

